export default __webpack_public_path__ + "static/og-521fac9a30e6680d6b5bee81de7071ac.jpg";